import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import { Table, Row } from 'react-bootstrap';
import notify from '../../shared/feedback/notifications';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import FormValidationService from '../../shared/form/FormValidationService';
import { assign } from '../../shared/Assign';
import FormSelect from '../../components/common/FormSelect';
import * as actions from './InvoiceActions';
import IFileUploads from './IFileUploads';

class ImportExportPage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            fileUploads: { files: [] },
            availableLegalEntities: [],
            errors: {}
        };

        this.onLegalEntityChange = this.onLegalEntityChange.bind(this);
        this.import = this.import.bind(this);
        this.fileChange = this.fileChange.bind(this);
    }

    fileChange(e: any): void {
        e.preventDefault();
        let fileUploads = { files: [] };
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.onloadend = () => {
            file.data = reader.result;
            fileUploads.files.push(file);
            this.setState({ fileUploads: fileUploads });
        };
        reader.readAsArrayBuffer(file);
    }

    import(): void {
        this.props.actions
            .importPayments(this.state.selectedLegalEntityId, this.state.fileUploads)
            .then(() => {
                this.setState({ fileUploads: { files: [] } });
                notify.success(Translate('invoice/payments/import/feedback/ok'));
                document.getElementById('file-input').value = '';
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors });
                })
            );
    }

    componentDidMount(): void {
        this.props.actions
            .getNewBgiFile()
            .then(
                () => (this.state.selectedLegalEntityId = this.props.availableLegalEntities[0].id)
            )
            .catch((error: any) => handleError(error));
    }

    onLegalEntityChange(e: any): void {
        let newState = assign({}, this.state);
        newState.selectedLegalEntityId = e.target.value;
        this.setState(newState);
    }

    render() {
        return (
            <div>
                <Row>
                    <h1 className="col-xs-12">
                        {Translate('invoice/payments/title/import-payments')}
                    </h1>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('invoice/payments/new/legal-entity')}
                        </ControlLabel>
                        <FormSelect
                            name="legalEntity"
                            value={this.state.selectedLegalEntityId as any}
                            onChange={this.onLegalEntityChange}
                        >
                            {this.props.availableLegalEntities.map((s: any) => {
                                return (
                                    <option key={s.id} value={s.id as any}>
                                        {s.name}
                                    </option>
                                );
                            })}
                        </FormSelect>
                    </FormGroup>
                    <FormGroup
                        validationState={FormValidationService.getValidationState(
                            this.state.errors.file
                        )}
                    >
                        <FormControl
                            id="file-input"
                            type="file"
                            name="file"
                            onChange={this.fileChange}
                        />
                        <HelpBlock>{this.state.errors.file}</HelpBlock>
                    </FormGroup>
                    <Button
                        disabled={
                            this.state.fileUploads.files.length === 0 ||
                            !this.state.selectedLegalEntityId
                        }
                        bsSize="large"
                        onClick={() => this.import()}
                        bsStyle="success"
                    >
                        {Translate('invoice/payments/import')}
                    </Button>
                </Row>
                {this.props.feedback.length > 0 && (
                    <Row>
                        <Table hover responsive>
                            <thead>
                                <tr>
                                    <th>
                                        {Translate('invoice/payments/import/feedback/list/ocr')}
                                    </th>
                                    <th>
                                        {Translate('invoice/payments/import/feedback/list/message')}
                                    </th>
                                    <th>
                                        {Translate('invoice/payments/import/feedback/list/amount')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.feedback.map((i: any) => (
                                    <tr
                                        key={i.ocr}
                                        className={
                                            i.message.type === 2
                                                ? 'bg-warning'
                                                : i.message.type === 3
                                                ? 'bg-danger'
                                                : ''
                                        }
                                    >
                                        <td>{i.ocr}</td>
                                        <td>{Translate(i.message.displayName)}</td>
                                        <td>{i.amount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Row>
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        feedback: state.invoices.import.feedback,
        availableLegalEntities: state.invoices.newImport.availableLegalEntities
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            importPayments: (legalEntityId: number, fileUploads: IFileUploads) =>
                dispatch(actions.importPayments(legalEntityId, fileUploads)),
            getNewBgiFile: () => dispatch(actions.newImportPayments())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImportExportPage));
